import angular from 'angular';

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('simTel', {
    url: '/sim-tel',
    templateProvider: () =>
      import(/* webpackChunkName: "sim-tel" */ './sim-tel.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'simTelCtrl as vm',
    requiredPermission: 'simTel',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "sim-tel" */ './sim-tel.controller'),
          import('../../extensions/init/ag-grid'),
          import('../../extensions/directives/select2'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
    },
  });
}

export default angular.module('app.sim-tel.routing', []).config(routes);
